import * as React from "react";
import PlaidLink, {PlaidEnv, PlaidLinkMeta, PlaidProduct} from "./components/PlaidLink";
import Config from "../../services/Config/Config";

export interface PlaidAuthenticationData {
  publicKey: string;
  institutionName: string;
  institutionId: string;
}

interface IProps {
  onAuthenticationFinished: (
    succeeded: boolean,
    data?: PlaidAuthenticationData
  ) => void;
  onConnectExit?: () => void;
}

export default class PlaidAuthenticator extends React.Component<IProps, {}> {
  public render() {
    const env = this.env();
    const products = [PlaidProduct.Auth, PlaidProduct.Assets, PlaidProduct.Transactions];
    return (
      <PlaidLink
        onExit={this.onExit}
        onSuccess={this.onPublicTokenReceived}
        publicKey={Config.plaidKey()!}
        env={env}
        products={products}
        clientName="Salaryo"
      />
    );
  }

  private onPublicTokenReceived = (publicKey: string, meta: PlaidLinkMeta) => {
    const { onAuthenticationFinished } = this.props;
    const institution = meta.institution;

    onAuthenticationFinished(true, {
      publicKey,
      institutionName: institution ? institution.name : "",
      institutionId: institution ? institution.institution_id : ""
    });
  };

  private onExit = () => {
    const { onAuthenticationFinished, onConnectExit } = this.props;
    onAuthenticationFinished(false);
    if(onConnectExit) {
      onConnectExit();
    }
  };

  private env() {
    const env = Config.isProd() ? PlaidEnv.Production : PlaidEnv.Sandbox;
    return env;
  }
}



// WEBPACK FOOTER //
// ./src/components/PlaidAuthenticator/PlaidAuthenticator.tsx